import { parsePhoneForApi, validatePhoneValue } from "@/utils/phoneInput";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const BLOG_TRAVELLER_OPTIONS = [
  { value: "1", label: "1 Person", count: 1 },
  { value: "2", label: "2 Persons", count: 2 },
  { value: "3", label: "3 Persons", count: 3 },
  { value: "4", label: "4 Persons", count: 4 },
  { value: "family", label: "Family Group", count: 5 },
];

export function createBlogEnquiryFormState() {
  return {
    fullName: "",
    email: "",
    phone: "",
    travelDate: "",
    noOfTravellers: "",
    description: "",
  };
}

export function createBlogSubscribeFormState() {
  return {
    emailId: "",
  };
}

export function createBlogCommentFormState() {
  return {
    userName: "",
    emailId: "",
    comment: "",
  };
}

export function getCurrentPageUrl() {
  if (typeof window === "undefined") return "";
  return window.location.href;
}

export function validateBlogEnquiryForm(form = {}) {
  const errors = {};

  if (!form.fullName?.trim()) {
    errors.fullName = "Full name is required";
  }

  if (!form.email?.trim()) {
    errors.email = "Email is required";
  } else if (!EMAIL_RE.test(form.email.trim())) {
    errors.email = "Enter a valid email";
  }

  const phoneError = validatePhoneValue(form.phone);
  if (phoneError) {
    errors.phone = phoneError;
  }

  if (!form.travelDate) {
    errors.travelDate = "Travel date is required";
  }

  if (!form.noOfTravellers) {
    errors.noOfTravellers = "Number of travelers is required";
  }

  return errors;
}

export function validateBlogSubscribeForm(form = {}) {
  const errors = {};

  if (!form.emailId?.trim()) {
    errors.emailId = "Email is required";
  } else if (!EMAIL_RE.test(form.emailId.trim())) {
    errors.emailId = "Enter a valid email";
  }

  return errors;
}

export function validateBlogCommentForm(form = {}) {
  const errors = {};

  if (!form.comment?.trim()) {
    errors.comment = "Comment is required";
  }

  if (!form.userName?.trim()) {
    errors.userName = "Full name is required";
  }

  if (!form.emailId?.trim()) {
    errors.emailId = "Email is required";
  } else if (!EMAIL_RE.test(form.emailId.trim())) {
    errors.emailId = "Enter a valid email";
  }

  return errors;
}

export function buildBlogEnquiryPayload(form = {}, { interestedIn = "" } = {}) {
  const parsedPhone = parsePhoneForApi(form.phone);
  const travellerOption = BLOG_TRAVELLER_OPTIONS.find(
    (option) => option.value === form.noOfTravellers
  );

  return {
    fullName: form.fullName.trim(),
    interestedIn: interestedIn || "",
    email: form.email.trim(),
    countryCode: parsedPhone?.countryCode || "",
    phone: parsedPhone?.phoneNo || "",
    description: form.description?.trim() || "",
    noOfTravellers: travellerOption?.count || Number(form.noOfTravellers) || 0,
    travelDate: form.travelDate
      ? new Date(form.travelDate).toISOString()
      : new Date().toISOString(),
    currentPageUrl: getCurrentPageUrl(),
  };
}

export function buildBlogSubscribePayload(form = {}) {
  return {
    emailId: form.emailId.trim(),
    currentPageUrl: getCurrentPageUrl(),
  };
}

export function buildBlogCommentPayload(form = {}, { blogId = 0 } = {}) {
  return {
    blogId: Number(blogId) || 0,
    userName: form.userName.trim(),
    emailId: form.emailId.trim(),
    comment: form.comment.trim(),
    currentPageUrl: getCurrentPageUrl(),
  };
}

export function isBlogApiSuccess(response) {
  if (!response) return false;
  const status = String(response.status || response.Status || "").toLowerCase();
  if (status === "success") return true;
  if (response.success === true) return true;
  return false;
}

export function getBlogApiErrorMessage(error, fallback = "Something went wrong.") {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.Message ||
    error?.message ||
    fallback
  );
}
